import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) =>
  (conversationID: number, toArchive: boolean) =>
    makeCall<undefined>(
      'PUT',
      `/api/v2/conversation/${conversationID}/${
        toArchive ? 'archive' : 'unarchive'
      }`,
    );
